<script setup lang="ts">
  import { Picture } from '@travelata-libs/ui-kit';

  const onSkolkovo = () => {
    window.open('https://sk.ru/');
  };
</script>

<template>
  <Picture
    path="partner/logo/skolkovo-member-white.svg"
    :lazy="false"
    :extensions="[]"
    :high-resolution="false"
    fit="contain"
    class="picture-skolkovo-logo"
    @click.capture="onSkolkovo"
  />
</template>

<style scoped lang="scss">
  .picture-skolkovo-logo {
    cursor: pointer;
    height: 24px;
    width: 74px;
  }
</style>
